












import PopupEpisode2 from '@/views/templates/tenugui/PopupEpisode2.vue'

export default
  components: {
    PopupEpisode2
  }

  data: () ->
    message: [
      '織りあがったばかりの生地は、油分や不純物を含んだ状態。ここで、 染色できるように不純物を取り除いていくことが大事です。'
    ]

  methods: {
    closePopup: () ->
      @$emit('closePopup')
    add_point: (point) ->
      @$emit('addPoint', point)
  }
